// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kaimo-docx-wrapper{padding:0!important;display:block!important;background-color:transparent!important}", ""]);
// Exports
module.exports = exports;
